import React from 'react';
import { FaInstagram } from 'react-icons/fa';

function FakeNewsSection() {
    return (
        <section className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-[#f0f4f8] px-4">
            <div className="w-full max-w-3xl text-center py-20">
                {/* Title */}
                <h1 className="text-4xl sm:text-5xl font-extrabold text-[#174997] mb-4">
                    Fake News from Pakistan
                </h1>

                {/* Subtitle */}
                <p className="text-gray-600 text-base sm:text-lg mb-8 font-montserrat">
                    Discover how misleading narratives are being spread and how we stand against them.
                </p>

                {/* Instagram Link */}
                <div className="flex justify-center">
                    <a
                        href="https://www.instagram.com/reel/DJW8AX3vycQ/?igsh=NzRuMGNmMTNsaGt5"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-[#174997] text-white px-6 py-3 rounded-full font-semibold shadow hover:bg-[#123b7d] transition-all"
                    >
                        <FaInstagram className="text-lg" />
                        Watch on Instagram
                    </a>
                </div>
            </div>
        </section>
    );
}

export default FakeNewsSection;
